import React, { useState, useEffect } from "react";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";
import axios from "axios";
import { Link } from "react-router-dom";
import { FiBell } from "react-icons/fi";

const API_URL = process.env.REACT_APP_API_URL;


const NotificationPage = () => {
  const [notifiche, setNotifiche] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0); // Stato per il conteggio delle notifiche non lette

  // Funzione per aggiornare il conteggio delle notifiche non lette
  const updateUnreadCount = () => {
    const unread = notifiche.filter((notifica) => !notifica.letto).length;
    setUnreadCount(unread);
  };

  useEffect(() => {
    const eventSource = new EventSource(`${API_URL}/admin/sendNotifications`);

    eventSource.onmessage = (event) => {
      const newNotification = JSON.parse(event.data);
      console.log("NOTIFICA NUOVA: ", newNotification);
      setNotifiche((prev) => [...prev, newNotification.notifica]);
    };

    // Pulire la connessione al dismount
    return () => {
      eventSource.close();
    };
  }, []);

  useEffect(() => {
    axios.defaults.withCredentials = true;
    console.log("Fetching notifiche...");
    const fetchNotifiche = async () => {
      try {
        const response = await axios.get(`${API_URL}/admin/notifications`);
        console.log(response.data);
        setNotifiche(response.data.notifiche);
      } catch (error) {
        console.log(error);
      }
    };
    fetchNotifiche();
  }, []);

  const segnaComeLetto = async (id) => {
    try {
      await axios.post(`${API_URL}/admin/markAsRead`, {
        id: [id], // id delle notifiche da aggiornare
      });
      setNotifiche((prev) =>
        prev.map((notifica) =>
          notifica.id === id
            ? { ...notifica, letto: !notifica.letto }
            : notifica
        )
      );

      // Aggiorna il badge delle notifiche non lette
      updateUnreadCount();
    } catch (error) {
      console.log(error);
    }
  };

  const segnaTutteComeLette = async () => {
    try {
      await axios.post(`${API_URL}/admin/markAllAsRead`);

      setNotifiche((prev) =>
        prev.map((notifica) => ({ ...notifica, letto: true }))
      );
      // Aggiorna il badge delle notifiche non lette
      updateUnreadCount();
      // Aggiorna il badge delle notifiche non lette
    } catch (error) {
      console.log(error);
    }
  };

  const groupByDate = (notifiche) => {
    return notifiche.reduce((groups, notifica) => {
      const date = new Date(notifica.data_creazione).toLocaleDateString();
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(notifica);
      return groups;
    }, {});
  };

  const groupedNotifiche = groupByDate(notifiche);

  return (
    <div>
      <Header />
      <div className="flex min-h-screen bg-gray-50">
        <Sidebar />
        <div className="flex-1 p-6">
          <div className="bg-white rounded-lg shadow-lg p-6">
            {/* Header notifiche */}
            <div className="flex justify-between items-center mb-6 border-b pb-4">
              <h1 className="text-2xl font-semibold text-gray-800">
                Notifiche
              </h1>
              <button
                className="text-blue-600 hover:text-blue-800 font-medium transition"
                onClick={() => segnaTutteComeLette()}
              >
                Segna tutte come lette
              </button>
            </div>

            {/* Lista notifiche divise per giorni */}
            {Object.keys(groupedNotifiche)
              .sort((a, b) => new Date(b) - new Date(a)) // Ordina i giorni in ordine decrescente
              .map((date) => (
                <div key={date} className="mb-6">
                  {/* Titolo del giorno */}
                  <h2 className="flex items-center text-lg font-semibold text-gray-800 mb-4">
                    <span
                      className={`${
                        date === new Date().toLocaleDateString()
                          ? "bg-blue-100 px-2 py-1 rounded-full"
                          : date ===
                            new Date(
                              new Date().setDate(new Date().getDate() - 1)
                            ).toLocaleDateString()
                          ? "bg-green-100 px-2 py-1 rounded-full"
                          : "bg-gray-100 px-2 py-1 rounded-full"
                      } inline-block`}
                    >
                      {date === new Date().toLocaleDateString()
                        ? "Oggi"
                        : date ===
                          new Date(
                            new Date().setDate(new Date().getDate() - 1)
                          ).toLocaleDateString()
                        ? "Ieri"
                        : date}
                    </span>
                  </h2>

                  {/* Lista notifiche del giorno */}
                  <ul className="mb-4">
                    {groupedNotifiche[date].map((notifica) => (
                      <li
                        key={notifica.id}
                        className={`flex items-start gap-4 p-4 border transition ${
                          notifica.letto
                            ? "bg-gray-100 border-gray-300"
                            : "bg-white border-gray-200"
                        }`}
                      >
                        {/* Icona notifiche */}
                        <div className="flex-shrink-0">
                          <div
                            className={`w-10 h-10 flex items-center justify-center rounded-full ${
                              notifica.letto
                                ? "bg-gray-200 text-gray-500"
                                : "bg-blue-100 text-blue-600"
                            }`}
                          >
                            <i className="fas fa-info"></i>
                          </div>
                        </div>

                        {/* Contenuto della notifica */}
                        <div className="flex-1 text-left self-start">
                          <h2 className="text-sm font-semibold text-gray-800">
                            {notifica.tipo ||
                              "Nessuna descrizione disponibile."}
                          </h2>
                          <p className="text-sm text-gray-600 mt-1">
                            {notifica.nome +
                              " " +
                              notifica.cognome +
                              " " +
                              notifica.messaggio}
                          </p>
                          <small className="text-xs text-gray-500 block mt-2">
                            {new Date(
                              notifica.data_creazione
                            ).toLocaleTimeString()}
                          </small>
                        </div>

                        {/* Pulsante "Segna come letto" */}
                        {!notifica.letto ? (
                          <button
                            className="text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
                            onClick={() => segnaComeLetto(notifica.id)}
                          >
                            Segna come letto
                          </button>
                        ) : (
                          <button
                            className="text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
                            onClick={() => segnaComeLetto(notifica.id)}
                          >
                            Segna come non letto
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const NotificationButton = () => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const eventSource = new EventSource(`${API_URL}/admin/sendNotifications`);

    eventSource.onmessage = (event) => {
      const notification = JSON.parse(event.data);
      console.log("Notifica ricevuta:", notification);
      // Aggiorna lo stato con la nuova notifica
      setUnreadCount((prev) => prev + 1);
    };

    return () => {
      eventSource.close();
    };
  }, []);

  useEffect(() => {
    const eventSource = new EventSource(`${API_URL}/admin/updateUnreadCount`);

    eventSource.onmessage = (event) => {
      const notification = JSON.parse(event.data);
      console.log("Numero ricevuto:", notification);
      // Aggiorna lo stato con la nuova notifica
      setUnreadCount(notification);
    };

    return () => {
      eventSource.close();
    };
  }, []);

  // Ottieni le notifiche non lette dal backend
  useEffect(() => {
    axios.defaults.withCredentials = true;
    const fetchCountUnreads = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/admin/unreadNotifications`
        );
        console.log(response.data);
        const notifications = response.data.unreads[0].cnt;

        setUnreadCount(notifications);
      } catch (error) {
        console.error("Errore durante il recupero delle notifiche:", error);
      }
    };
    fetchCountUnreads();
  }, []);

  return (
    <Link
      to="/admin/notifiche"
      className="relative text-xl sm:text-3xl lg:text-2xl m-2"
    >
      <FiBell className="text-gray-800" />
      {/* Aggiungi il badge con il conteggio delle notifiche non lette */}
      {unreadCount > 0 && (
        <span className="absolute -top-4 -right-3 w-5 h-5 text-white bg-red-500 text-xs rounded-full flex items-center justify-center">
          {unreadCount}
        </span>
      )}
    </Link>
  );
};

export default NotificationPage;
